import React from 'react';
import styles from './TokenSettingsTab.module.css';
import { FieldMeta } from '../../../types/webchatTabsTypes';
import InfoLabel from '../../../ui/InfoLabel/InfoLabel';

const KeyIndicator: React.FC<{ field: FieldMeta; showKeys: boolean }> = ({ field, showKeys }) =>
  showKeys ? (
    <span className={styles.keyBadge}>{field.key}</span>
  ) : (
    <InfoLabel content={field.details ?? field.description} />
  );

export default KeyIndicator;
